import styled, { css } from 'styled-components'
import { breakpoint } from 'utils'

const ModalBody = styled.div(
  ({ theme }) => css`
    padding: 0 16px 16px;

    ${breakpoint('sm')`
      padding: 0 32px 32px;
    `}

    font-size: ${theme.fontSizes.small};
    color: ${theme.colors.foreground.secondary[3]};
    line-height: 1.4;
  `
)

export default ModalBody
